<template>
  <div
    ref='rootRef'
    class='map-switcher-wrapper'
  >
    <div
      class='map-switcher'
      :class='{
        "is-active": isVisible
      }'
    >
      {{ containerOffset }}
      <ul>
        <li
          :class="{ 'is-active': !isMapActive }"
          @click="isMapActive ? toggleMap() : null"
        >
          {{ tp('list') }}
        </li>
        <li
          :class="{ 'is-active': isMapActive }"
          @click="isMapActive ? null : toggleMap()"
        >
          {{ tp('map') }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapSwitcher',
  inheritAttrs: false
};
</script>

<script setup>
import { ref } from 'vue';

import callbackOnScroll from '@/vue/composables/callback_on_scroll';

import offset from '@/helpers/offset';
import { prepared } from '@/helpers/i18n';

const props = defineProps({
  isMapActive: { type: Boolean, required: true },
  i18nKey: { type: String, required: true },
  containerNode: { type: Object, required: false, default: undefined }
});
const emit = defineEmits(['toggle-map']);
const tp = prepared(props.i18nKey);

const VISIBILITY_OFFSET = 100;

const containerOffset = ref(null);
const rootRef = ref(null);
const isVisible = ref(true);

function toggleMap() {
  emit('toggle-map');
}

callbackOnScroll(() => {
  const containerNodeTop = offset(props.containerNode).top;
  const containerNodeBottom = containerNodeTop +
    props.containerNode.clientHeight;

  const rootNodeTop = offset(rootRef.value).top;
  const rootNodeBottom = rootNodeTop + rootRef.value.clientHeight;

  if (isVisible.value &&
    (rootNodeTop < containerNodeTop - VISIBILITY_OFFSET * 1.5 ||
      rootNodeBottom > containerNodeBottom + VISIBILITY_OFFSET * 4.5)
  ) {
    isVisible.value = false;
  } else if (!isVisible.value &&
    (rootNodeTop >= containerNodeTop - VISIBILITY_OFFSET &&
      rootNodeBottom <= containerNodeBottom + VISIBILITY_OFFSET * 3)
  ) {
    isVisible.value = true;
  }
});
</script>

<style scoped lang="sass">
@import 'app/packs/stylesheets/functions/rem'
@import 'app/packs/stylesheets/mixins/responsive'
@import 'app/packs/stylesheets/variables'

.map-switcher-wrapper
  bottom: rem(24px)
  left: 50%
  pointer-events: none
  position: fixed
  z-index: $z-index-sticky_area

.map-switcher
  pointer-events: all
  transition: transform 750ms
  transform: translateX(-50%) translateY(200%)

  &.is-active
    transform: translateX(-50%) translateY(0%)

  ul
    align-items: center
    background: var(--gray-200)
    border-radius: rem4(64px)
    box-shadow: 0px 0px 24.944px 0px rgba(3, 3, 3, 0.10)
    display: flex
    gap: rem4(4px)
    padding: rem4(4px)

    li
      background: var(--gray-200)
      border-radius: 32px
      display: flex
      font-size: rem4(16px)
      font-weight: 600
      line-height: rem4(20px)
      padding: rem4(10px) rem4(16px)
      transition: background var(--transition-duration)
      white-space: nowrap

      &:not(.is-active)
        cursor: pointer

      &.is-active
        background: #FFF
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.05)
</style>
